import React from "react"
import CustomButton, { CustomButtonProps } from "../../Atoms/CustomButton"
import classNames from "utils/classNames"

const CenterButton = ({
  onClick,
  className,
  ...otherProps
}: CustomButtonProps) => {
  return (
    <CustomButton
      className={classNames("vt-map-center-button", className)}
      icon="locate"
      text="Center Map"
      onClick={onClick}
      {...otherProps}
    />
  )
}

export default CenterButton
